import { useEffect, useState } from 'react'
import { Button, Modal, Form } from 'react-bootstrap'
import { NewPlayerRequest } from '../../../Api/Requests/models'
import { BsChatLeftText, BsPersonFillAdd } from 'react-icons/bs'
import { useAdminInfo } from '../../../../../hooks/useAdminInfo'
import { RejectUserModal } from './RejectUserModal'
import { useCreatePlayerAndUser } from '../hooks/useCreatePlayerAndUser'
import { useGetRandomUser } from '../../../../../hooks/useGetRandomUser'
import { useNavigate } from 'react-router-dom'

interface OpenRequestModalProps {
    show: boolean
    onHide: () => void
    request: NewPlayerRequest
    fetchRequests: () => void
}

export const OpenNewPlayerRequestModal = ({ show, onHide, request, fetchRequests }: OpenRequestModalProps) => {
    const navigate = useNavigate()
    const { adminInfo, getAdminInfo } = useAdminInfo()
    const { getPlatformUser } = useGetRandomUser()
    const [loading, setLoading] = useState(false)
    const [showReject, setShowReject] = useState(false)

    const [form, setForm] = useState({
        firstName: request?.firstName ?? '',
        lastName: request?.lastName ?? '',
        email: request?.email ?? '',
        phone: request?.phone ?? '',
        platformUser: '',
        password: 'gestor_123',
        createdInPromo: true
    })


    const { handleCreateUser } = useCreatePlayerAndUser({
        loading,
        setLoading,
        form,
        setForm,
        adminInfo,
        onHide,
        requestId: request?.id,
    })


    const closeBothModals = () => {
        setShowReject(false)
        onHide()
    }

    useEffect(() => {
        const randomNumber1to99 = Math.floor(Math.random() * 999) + 1;
        const firstNameAnd4RandomNumbers = `${request?.firstName?.substring(0, 5)}_${randomNumber1to99}`;
        const replaceSpaces = firstNameAnd4RandomNumbers.replace(/\s+/g, '');
        setForm({
            firstName: request?.firstName ?? '',
            lastName: request?.lastName ?? '',
            email: request?.email ?? '',
            phone: request?.phone ?? '',
            platformUser: request?.status === 'pending' ? getPlatformUser(request?.firstName ?? '') : request?.platformUser ?? '',
            password: replaceSpaces?.toLowerCase(),
            createdInPromo: true
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request])

    useEffect(() => {
        if (!adminInfo) {
            getAdminInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adminInfo]);

    useEffect(() => {
        if (adminInfo?.firstLetter) {
            setForm({ ...form, platformUser: getPlatformUser(request?.firstName ?? '') })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adminInfo]);


    const requestClosed = request?.status === 'approved' || request?.status === 'rejected'


    return (
        <>
            {showReject && <RejectUserModal
                closeBothModals={closeBothModals}
                show={showReject}
                onHide={() => setShowReject(false)}
                request={request}
                fetchRequests={fetchRequests}
            />}
            <Modal show={show} onHide={onHide} size='lg' backdrop="static" keyboard={false} centered>
                <div className="border border-secondary rounded-3 px-4">
                    <Modal.Header closeButton>
                        <Modal.Title>Solicitud de nuevo jugador<br /> <span className='text-primary'>{request.email}</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body >

                        <div className="mt-2">
                            Nuevo jugador:
                            <br />
                            <span className="text-primaryy">{request.firstName} {request.lastName}</span>
                        </div>
                        <div className="mt-2">
                            Email:
                            <br />
                            <span className="text-primaryy">{request.email}</span>
                        </div>
                        <div className="mt-2">
                            Teléfono:
                            <br />
                            <span className="text-primaryy">{request.phone}</span>
                        </div>

                        {request?.status === 'pending' &&
                            <>
                                <div className="my-4">
                                    Nombre de Usuario <span className='text-warning'>*</span>
                                    <Form.Control
                                        type="text"
                                        placeholder="Nombre de usuario"
                                        disabled={requestClosed}
                                        value={form.platformUser}
                                        onChange={(e) => setForm({ ...form, platformUser: e.target.value.replace(/\s+/g, '') })}
                                    />
                                </div>

                                <div className="my-4">
                                    Contraseña <span className='text-warning'>*</span>
                                    <Form.Control type="text" placeholder="Contraseña" disabled={requestClosed} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
                                </div>

                                <Form.Group className="mb-4 d-flex align-items-center gap-2 mx-1">
                                    Creado en promoción
                                    <Form.Check
                                        type="switch"
                                        label=""
                                        style={{ width: 'fit-content' }}
                                        name="active"
                                        checked={form?.createdInPromo || false}
                                        onChange={(e) => setForm({ ...form, createdInPromo: e.target.checked })}
                                        className="text-light"
                                    />
                                    <span className='text-secondary text-xss'>{form?.createdInPromo ? '✅' : 'No'}</span>
                                </Form.Group>
                                <hr />
                                <div className='mt-4 text-warning text-center'>
                                    <span className='text-primaryy'>Se creará un usuario con el nombre de usuario {form.platformUser}.</span>
                                    <br />
                                    <br />
                                    Al finalizar, se te copiará un resumen de los datos en el portapapeles, para que puedas enviarlo por email/whatsapp al jugador.
                                </div>
                            </>
                        }


                        {request?.status === 'approved' &&
                            <div className='mt-2 text-success text-center'>
                                <span className='text-primaryy'>El jugador {request.platformUser} ha sido creado correctamente.</span>
                                <div className='mt-2 d-flex justify-content-end'>
                                    <Button variant='primary'
                                        className='d-flex align-items-center gap-2'
                                        onClick={() => navigate(`/dashboard/chat?playerId=${request.id}`)}
                                    >
                                        <BsChatLeftText size={18} />
                                        Iniciar chat
                                    </Button>
                                </div>
                            </div>
                        }

                        {request?.status === 'rejected' &&
                            <div className='mt-2 text-danger text-center'>
                                <span className='text-danger'>La solicitud ha sido rechazada.</span>
                                <br />
                                <br />
                                <span className='text-white'>Motivo: {request.reason}</span>
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-between w-100'>

                            <div className='d-flex align-items-center gap-2'>
                                {request?.status === 'pending' && <Button variant="danger" onClick={() => setShowReject(true)}> Rechazar </Button>}
                            </div>

                            {request?.status === 'pending' &&
                                <div className='d-flex align-items-center gap-2'>
                                    <div className='d-flex align-items-center gap-2'>
                                        <Button variant="primary"
                                            onClick={() => handleCreateUser()}
                                            className='d-flex align-items-center gap-2'
                                            disabled={loading}
                                        >
                                            <BsPersonFillAdd size={18} />
                                            {loading ? 'Creando...' : 'Crear usuario y jugador'}
                                        </Button>
                                    </div>
                                </div>
                            }

                        </div>
                    </Modal.Footer>
                </div >
            </Modal >
        </>
    )
}
